import { fetchAuth } from '../stores/user.store'
import { useService } from 'services'
import { useDispatch, useSelector } from 'stores'
import { STORE_STATUS_FINISHED } from 'constants/store'
import { useWebView } from 'modules/web-view'
import { WebViewPostMessageType } from '@types'

export function useAuth() {
  const dispatch = useDispatch()
  const { auth: service } = useService()
  const user = useSelector((state) => state.auth.user)
  const { sendMessage } = useWebView()

  const subscribe = (
    notAuthenticatedCallback: () => void,
    authenticatedCallback?: () => void
  ) => {
    return service.onAuthStateChange((userFirebase) => {
      dispatch(fetchAuth(userFirebase))
      if (!userFirebase?.token) {
        notAuthenticatedCallback()
        sendMessage({ type: WebViewPostMessageType.LOGOUT, data: userFirebase })
      } else if (userFirebase.token && !userFirebase.isAnonymous) {
        authenticatedCallback?.()
      }
    })
  }

  function isAuthReady() {
    return (
      user.status === STORE_STATUS_FINISHED &&
      user.data.token &&
      !user.data.isAnonymous
    )
  }

  return { subscribe, auth: user, isAuthReady }
}
